import axios from '@/components/plugins/axios'
const url = process.env.VUE_APP_API_URL

class Orders {
  get (slug) {
    return axios.get(url + '/restaurant-manager/orders/' + slug)
  }

  getAll (params, filters = null) {
    let options = '?page=' + params.page + '&per_page=' + params.per_page
    if (typeof (params.search) !== 'undefined') {
      options += '&search=' + params.search
    }
    if (filters !== null) {
      Object.keys(filters).forEach(key => {
        if(typeof filters[key] !== 'string') {
          options += '&filters[' + key + ']=[' + filters[key] + ']'
        } else {
          options += '&filters[' + key + ']=' + filters[key]
        }
      })
    }
    return axios.get(url + '/restaurant-manager/orders' + options)
  }

  store (data) {
    return axios.post(url + '/restaurant-manager/orders', data)
  }

  update (id, data) {
    return axios.put(url + '/restaurant-manager/orders/' + id, data)
  }

  report(filters) {
    return axios.post(url + '/restaurant-manager/orders/report', filters)
  }

  /*
  delete (id) {
    return axios.delete(url + '/restaurant-manager/orders/' + id)
  }
   */
}
export default new Orders()
